import { render, staticRenderFns } from "./BImageWithBlurredBackground.vue?vue&type=template&id=62130967&scoped=true"
import script from "./BImageWithBlurredBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./BImageWithBlurredBackground.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BImageWithBlurredBackground.vue?vue&type=style&index=0&id=62130967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62130967",
  null
  
)

export default component.exports